import { SVGProps } from 'react'

const PlaySVG = ({ color = '#fff', ...props }: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <g>
            <path
              d="M6.1 18.2c.608 0 1.1.492 1.1 1.1v5.5h5.5c.608 0 1.1.492 1.1 1.1 0 .608-.492 1.1-1.1 1.1H6.1c-.608 0-1.1-.492-1.1-1.1v-6.6c0-.608.492-1.1 1.1-1.1zm19.8 0c.608 0 1.1.492 1.1 1.1v6.6c0 .608-.492 1.1-1.1 1.1h-6.6c-.608 0-1.1-.492-1.1-1.1 0-.608.492-1.1 1.1-1.1h5.5v-5.5c0-.608.492-1.1 1.1-1.1zM12.7 5c.608 0 1.1.492 1.1 1.1 0 .608-.492 1.1-1.1 1.1H7.2v5.5c0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1V6.1C5 5.492 5.492 5 6.1 5h6.6zm13.2 0c.608 0 1.1.492 1.1 1.1v6.6c0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1V7.2h-5.5c-.608 0-1.1-.492-1.1-1.1 0-.608.492-1.1 1.1-1.1z"
              transform="translate(-936 -266) translate(416 250) translate(520 16)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default PlaySVG
